"use client";
import * as React from "react";
const SvgForestSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 13", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M10.67 6.5 6 0 1.33 6.5h1.24L0 10.4h4.67V13h2.66v-2.6H12L9.43 6.5z" }), /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.43 6.5h1.24L10 0 8.4 2.22l3.55 4.93h-1.3l2.14 3.25H16zm-2.1 4.55H8.67V13h2.66z" }));
export {
  SvgForestSharp as default
};
